export const Relationship = ({ data, options }) => {
    return options?.relationship ? options.relationship(data) : undefined;
};
